import { formatHundredths } from '../decimal.ts';

/** The sentence a circle's prompts and a round solid's volume share (ADR 0140 §4). */
const piSentence = () => `Utilise 3,14 pour pi.`;

/** French circle prompts (ADR 0106 §3). A French student writes a decimal comma. */
export const circlePrompts = {
    piSentence,
    circumference: () => `Trouve la circonférence. ${piSentence()}`,
    area: () => `Trouve l'aire. ${piSentence()}`,
    diameterFromCircumference: (circumference: string) =>
        `La circonférence est de ${circumference}. ${piSentence()} Quel est le diamètre ?`,
    decimal: (hundredths: number) => formatHundredths(hundredths, ','),
};
